
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.097 2.354A6.216 6.216 0 0017.103.917a6.33 6.33 0 00-4.51 1.882c-.21.215-.408.446-.592.697-1.43-1.93-3.82-2.92-6.182-2.482-1.961.361-3.503 1.454-4.58 3.246C-.278 6.79-.402 9.23.873 11.513c.682 1.221 1.567 2.412 2.706 3.639 2.085 2.247 4.553 4.38 7.768 6.711.205.15.425.225.654.225.354 0 .592-.18.71-.27 2.901-2.1 5.18-4.036 7.171-6.095 1.113-1.15 2.375-2.563 3.298-4.327.396-.754.847-1.768.82-2.927-.06-2.495-1.035-4.552-2.902-6.115z","fill":"#828282"}})])
          )
        }
      }
    